import { atom } from 'recoil';
import { UserNotification } from '../../../hooks/useNotifications/UserNotification';

const NotificationsAtom = atom<UserNotification[]>({
  default: [],
  key: 'notifications-atom',
});

export default NotificationsAtom;
